<template>
  <div class="toast-wrapper">
    <div class="toast-body">
      {{ text ? text : 'missing text' }}
    </div>
  </div>
</template>

<script>
  export default {
    props: [
        'text',
    ],
    data() {
      return {}
    },
  }
</script>

<style>
.toast-body {
  padding: 20px !important;
  color: white;
  background: #224494;
  box-shadow: 1px 3px 5px rgba(0,0,0,0.2);
  max-width: 400px;
  margin: 0 auto;
  border: 1px solid white;
}
@media screen and (max-width: 425px){
  .toast-body{
    text-align: center;
  }
}
</style>